var irreducible = require('./irreducible');
var isArray = require('./isArray');

module.exports = irreducible('Array', isArray);



//////////////////
// WEBPACK FOOTER
// ../~/tcomb/lib/Array.js
// module id = 3016
// module chunks = 1